import React from 'react';
import './App.css';
import KitenInfoBlock from './pages/KaitenInfo/KaitenInfo';

function App() {
  return (
    <div className="App">
      <KitenInfoBlock></KitenInfoBlock>
    </div>
  );
}

export default App;
